module.exports = __webpack_public_path__ + "img/case_05.4e35f855.jpg";